<template>
  <div>
    <inputbox
      type="number"
      :name="name"
      :helper="helper"
      :label="label"
      :value="value"
      @input="updateValue"
    >
      <button
        slot="leftBtn"
        type="button"
        class="btn btn-default"
        @click="decrement"
      >
        -
      </button>
      <button
        slot="rightBtn"
        type="button"
        class="btn btn-default"
        @click="increment"
      >
        +
      </button>
    </inputbox>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    label: String,
    helper: String,
    showError: Boolean,
    placeholder: String,
    stacked: Boolean,
    value: [String, Number],
    required: Boolean,
    readonly: Boolean,
    id: String,
    errorMessage: String
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    decrement() {
      if (this.value > 0) {
        const value = this.value - 1;

        this.updateValue(value);
      }
    },
    increment() {
      const value = this.value + 1;

      this.updateValue(value);
    }
  },

  watch: {}
};
</script>
